var map = {
	"./g04p01.jpg": 4023,
	"./g04p02.jpg": 4199,
	"./g04p03.jpg": 2625,
	"./g04p04.jpg": 4522,
	"./g04p05.jpg": 7527,
	"./g04p06.jpg": 2682,
	"assets/newCollection/homeOffice/FaceTime/group4/g04p01.jpg": 4023,
	"assets/newCollection/homeOffice/FaceTime/group4/g04p02.jpg": 4199,
	"assets/newCollection/homeOffice/FaceTime/group4/g04p03.jpg": 2625,
	"assets/newCollection/homeOffice/FaceTime/group4/g04p04.jpg": 4522,
	"assets/newCollection/homeOffice/FaceTime/group4/g04p05.jpg": 7527,
	"assets/newCollection/homeOffice/FaceTime/group4/g04p06.jpg": 2682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6853;